<template>
  <b-modal id="categorySelectError" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
    <div class="error-wrapper p-3">
      <div class="mb-4 text-center">
        <img src="@/assets/images/checked1.svg" />
      </div>
      <div class="error-title text-center" style="font-size: 15px">هیچ فایلی برای آپلود انتخاب نکرده اید.</div>
      <div class="mt-3 float-right w-100">
        <div class="d-flex align-items-center justify-content-center mx-3">
          <b-button class="col-6" style="background-color: #74788d; color: white; font-size: 13px" variant="secondary" block @click="$bvModal.hide('categorySelectError')"
            >انصراف</b-button
          >
          <b-button class="ms-2 col-6" style="background-color: #556ee6; color: white; font-size: 13px" variant="primary" block @click="$bvModal.hide('categorySelectError')"
            >متوجه شدم</b-button
          >
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  mounted() {
    this.$bvModal.show('categorySelectError')
  },
  beforeDestroy(){
      this.$bvModal.hide('categorySelectError')
  }
}
</script>

<style></style>
